import { ClientReviewType, ReviewType } from '../types';

export const getLatestReview = (reviews: ReviewType[], isClient = false) => {
  if (isClient) {
    return reviews.find((x) => x.reviewStatus === 'ACCEPT');
  }

  const reviewData = reviews.reduce(
    (latest: (typeof reviews)[0] | null, current: (typeof reviews)[0]) => {
      if (
        !latest ||
        new Date(current.reviewSendDate) > new Date(latest.reviewSendDate) ||
        !current?.reviewSendDate
      ) {
        return current;
      }
      return latest;
    },
    null,
  );

  return reviewData;
};

export const getLatestClientReview = (reviews: ClientReviewType[]) => {
  const reviewData = reviews.reduce(
    (latest: (typeof reviews)[0] | null, current: (typeof reviews)[0]) => {
      if (
        !latest ||
        new Date(current.reviewSendDate) > new Date(latest.reviewSendDate) ||
        !current?.reviewSendDate
      ) {
        return current;
      }
      return latest;
    },
    null,
  );

  return reviewData;
};

export const getReviewHistory = (reviews: ReviewType[], isClient = false) => {
  const latestReview = getLatestReview(reviews);
  const historyReviewData = reviews.filter((review) => {
    if (
      latestReview?.reviewStatus === 'PENDING' &&
      review._id === latestReview?._id
    ) {
      return false;
    }
    if (isClient && review.reviewStatus !== 'ACCEPT') {
      return false;
    }

    return true;
  });

  return historyReviewData;
};
